<script>
export default {
  name: "CancelSubscription",

  data() {
    return {
      isConfirm: true,
    };
  },

  watch: {
    isConfirm(newValue) {
      this.$emit("isConfirm", newValue);
    },
  },
};
</script>

<template>
  <div class="step-block">
    <p>{{ $t("account.sorryToSeeYouGo") }}</p>

    <eg-b-form-checkbox v-model="isConfirm" class="w-100 mb-1">
      {{ $t("account.cancelFinalConfirm") }}
    </eg-b-form-checkbox>
  </div>
</template>
